module.exports = __webpack_public_path__ + "static/media/om_eyeshape_monolid_grey.d28e7d15.png";